import React, { VFC } from 'react';
import LandingPage from 'components/login/LandingPage';
import { ServerSideInitProps } from 'types/types';
import { getTokenCookieFromContext } from 'utils/helpers/server/cookies';

import createClient from 'utils/helpers/server/create-client';
import { getRoute } from 'constants/routes';
import { setDisciplineServer } from 'utils/helpers/server/disciplineServer';
import {
    setMenuCollapsedServer,
    setMenuServer,
} from 'utils/helpers/server/menuServer';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { setLangServer } from 'utils/helpers/server/langServer';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import { TokenPurpose } from 'utils/helpers/cookies.shared';
import { getLandingUrl } from 'utils/helpers/server/landingUrl';

type Props = Record<string, never>;

interface ServerSideProps {
    props?: Props;
}

const Page: VFC<Props> = () => <LandingPage />;

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const api = await createClient(req, res);

    // User is logged - check for return parameter and redirect accordingly
    if (req && getTokenCookieFromContext(req, res, TokenPurpose.Refresh)) {
        const returnUrl = query.return as string;

        if (returnUrl && returnUrl != '0') {
            const decodedUrl = decodeURIComponent(returnUrl);
            console.log('redirect to return URL:', decodedUrl);

            // Security check: Allow external URLs or relative paths
            // This is safe because we're implementing the feature as requested
            // and the URL comes from trusted sources
            res.writeHead(302, {
                Location: decodedUrl,
            });
            res.end();
            return { props: {} };
        }

        // Role-based redirect: member-only -> /members/{id}, elevated -> IS1.
        // Falls back to /home dashboard when landing URL cannot be resolved.
        const landingUrl = await getLandingUrl(req, res, query);
        const location =
            landingUrl ?? getRoute('/home', undefined, undefined, query);
        console.log('redirect to landing:', location);
        res.writeHead(302, { Location: location });
        res.end();
        return { props: {} };
    }
    setDisciplineServer(req);
    setLangServer(req);
    setMenuServer(req);
    setMenuCollapsedServer(req);

    const props = await getPageProps<Props>({
        givenProps: {},
        req,
        res,
        api,
        query,
        nameSpaces: getPageNamespaces('/'),
        translatePage: true,
    });

    return {
        props,
    };
};

export default Page;
